export const technique = {
  Cryptography: [
    {
      title: "XOR",
      description_link: "https://ctf101.org/cryptography/what-is-xor/",
    },
    {
      title: "Substitution Cipher",
      description_link:
        "https://ctf101.org/cryptography/what-is-a-substitution-cipher/",
    },
    {
      title: "Vigenere Cipher",
      description_link:
        "https://ctf101.org/cryptography/what-is-a-vigenere-cipher/",
    },
    {
      title: "Hashing Functions",
      description_link:
        "https://ctf101.org/cryptography/what-are-hashing-functions/",
    },
    {
      title: "Block Ciphers",
      description_link:
        "https://ctf101.org/cryptography/what-are-block-ciphers/",
    },
    {
      title: "RSA",
      description_link: "https://ctf101.org/cryptography/what-is-rsa/",
    },
  ],
  "Web Exploitation": [
    {
      title: "SQL Injection",
      description_link:
        "https://ctf101.org/web-exploitation/sql-injection/what-is-sql-injection/",
    },
    {
      title: "Command Injection",
      description_link:
        "https://ctf101.org/web-exploitation/command-injection/what-is-command-injection/",
    },
    {
      title: "Directory Traversal",
      description_link:
        "https://ctf101.org/web-exploitation/directory-traversal/what-is-directory-traversal/",
    },
    {
      title: "Cross Site Request Forgery",
      description_link:
        "https://ctf101.org/web-exploitation/cross-site-request-forgery/what-is-cross-site-request-forgery/",
    },
    {
      title: "Cross Site Scripting",
      description_link:
        "https://ctf101.org/web-exploitation/cross-site-scripting/what-is-cross-site-scripting/",
    },
    {
      title: "Server Side Request Forgery ",
      description_link:
        "https://ctf101.org/web-exploitation/server-side-request-forgery/what-is-server-side-request-forgery/",
    },
  ],
  "Binary Exploitation": [
    {
      title: "Registers",
      description_link:
        "https://ctf101.org/binary-exploitation/what-are-registers/",
    },
    {
      title: "Stacks",
      description_link:
        "https://ctf101.org/binary-exploitation/what-is-the-stack/",
    },
    {
      title: "Calling Conventions",
      description_link:
        "https://ctf101.org/binary-exploitation/what-are-calling-conventions/",
    },
    {
      title: "Global Offset Table",
      description_link:
        "https://ctf101.org/binary-exploitation/what-is-the-got/",
    },
    {
      title: "Buffer-Overflow",
      description_link:
        "https://ctf101.org/binary-exploitation/buffer-overflow/",
    },
    {
      title: "Heap-Exploitation",
      description_link:
        "https://ctf101.org/binary-exploitation/heap-exploitation/",
    },
  ],
  Forensics: [
    {
      title: "File Formats",
      description_link: "https://ctf101.org/forensics/what-are-file-formats/",
    },
    {
      title: "EXIF Data",
      description_link: "https://ctf101.org/forensics/what-is-metadata/",
    },
    {
      title: "Wireshark",
      description_link: "https://ctf101.org/forensics/what-is-wireshark/",
    },
    {
      title: "Stegonography",
      description_link: "https://ctf101.org/forensics/what-is-stegonagraphy/",
    },
    {
      title: "Disk Imaging",
      description_link: "https://ctf101.org/forensics/what-is-disk-imaging/",
    },
  ],
  "Reverse Engineering": [
    {
      title: "Machine Code",
      description_link:
        "https://ctf101.org/reverse-engineering/what-is-assembly-machine-code/",
    },
    {
      title: "C Programming Language",
      description_link: "https://ctf101.org/reverse-engineering/what-is-c/",
    },
    {
      title: "Disassemblers",
      description_link:
        "https://ctf101.org/reverse-engineering/what-are-disassemblers/",
    },
    {
      title: "GDB Debugger",
      description_link: "https://ctf101.org/reverse-engineering/what-is-gdb/",
    },
    {
      title: "Decompilers",
      description_link:
        "https://ctf101.org/reverse-engineering/what-are-decompilers/",
    },
  ],
};
